import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { P } from 'shared';
function DisclosureFooter({ termLength, loanAmount, calculatedApr, promotionalPeriod, className = '', variant = 'body-small', }) {
    const formattedLoanAmount = loanAmount
        ? `$${Number(loanAmount).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })}`
        : '';
    return (_jsxs("div", { className: classNames('disclosure-footer w100', className), children: [_jsx("hr", { className: "flex-finalize-divider" }), promotionalPeriod && (_jsxs(P, { variant: variant, className: "color-gray mar-t-8 w100", children: [_jsx("sup", { children: "\u2020" }), "Based on a ", promotionalPeriod, " month deferred finance charge promotional period."] })), _jsxs(P, { variant: variant, className: "color-gray mar-t-8 w100", children: [_jsx("sup", { children: "^" }), "Based on a ", termLength, "-month ", formattedLoanAmount, ' ', "transaction at ", calculatedApr, "% APR."] })] }));
}
export default DisclosureFooter;
